const langAuthLogin = {
	title: {
		tag: 'auth.login.title',
		fr: 'Identifiez-vous',
		en: 'Sign in',
	},
	email: {
		tag: 'auth.login.email',
		fr: 'E-mail',
		en: 'Email',
	},
	password: {
		tag: 'auth.login.password',
		fr: 'Mot de passe',
		en: 'Password',
	},
	btn_next: {
		tag: 'auth.login.btn_next',
		fr: 'Valider',
		en: 'Next',
	},

	btn_login: {
		tag: 'auth.login.btn_login',
		fr: 'Se connecter',
		en: 'Login',
	},
	// btn_login_with: {
	// 	tag: 'auth.login.btn_login_with',
	// 	fr: 'Se connecter avec {{service_name}}',
	// 	en: 'Login with {{service_name}}',
	// },
	// divider_or: {
	// 	tag: 'auth.login.divider_or',
	// 	fr: 'ou',
	// 	en: 'or',
	// },
	forget_password: {
		tag: 'auth.login.forget_password',
		fr: 'Mot de passe oublié ?',
		en: 'Reset password ?',
	},
	remember_me: {
		tag: 'auth.login.remember_me',
		fr: 'Se souvenir de moi',
		en: 'Remember me',
	},
	btn_faq: {
		tag: 'auth.login.btn_faq',
		fr: 'Aide',
		en: 'FAQ',
	},
	loader_authentification: {
		tag: 'auth.login.loader_authentification',
		fr: 'Authentification en cours...',
		en: 'Authentification in progress...',
	},
	text_you_will_identify_as: {
		tag: 'auth.login.text_you_will_identify_as',
		fr: "Vous allez vous connecter avec <strong>{{login}}</strong>, si ce n'est pas votre identifiant veuillez",
		en: 'You will login with <strong>{{login}}</strong>, if this is not your login please',
	},
	text_link_change_account: {
		tag: 'auth.login.text_link_change_account',
		fr: 'cliquez ici pour changer de compte',
		en: 'click here to change your account',
	},
	btn_access_employee: {
		tag: 'auth.login.btn_access_employee',
		fr: 'Accès employé',
		en: 'Employee access',
	},
	btn_access_investor: {
		tag: 'auth.login.btn_access_investor',
		fr: 'Accès investisseur',
		en: 'Investor access',
	},
};

export default langAuthLogin;
